export const filterId = 'saleType' as const
